const strings = {
	app: {
		url:'unic.ichuk.ru'
	},
	groups: {
		leaveConfirm: (me) => `Чтобы вернутся, ${me?'вам':'ему'} понадобится приглашение`
	}
}

export default strings